import { lazy, Suspense } from 'react';
import type { ModuleRoute } from "@herbo/module-route";

/**
 * Routes d'entrée du module `herbo-lot-detail`.
 *
 * Conventions de l'AIOS :
 *   - `path` relatif (sans slash de tête)
 *   - `element` = composant lazy pour éviter d'inclure ce module dans le
 *     bundle initial du shell.
 *
 * Ben 22/07 : l'onglet "Fiche lot" menait directement à
 * `/lot-detail/:numLot`, qui EXIGE un numéro déjà connu — impasse pour qui
 * clique l'onglet sans un numéro en tête. La page liste (`/lots`) devient le
 * point d'atterrissage et le SEUL onglet visible ; la fiche détail reste
 * routable à la même URL `/lot-detail/:numLot` qu'avant (liens depuis la
 * liste, favoris, partages) mais n'a plus son propre onglet — `hidden: true`
 * (cf. `apps/web/src/routes/modules.ts` / `TopBar.tsx`, changement additif :
 * tout module qui ne le déclare pas garde son comportement identique).
 *
 * L'auto-discovery côté web charge ce fichier via `import.meta.glob` (cf.
 * `apps/web/src/routes/modules.ts`) — un `export default` en tableau expose
 * plusieurs routes top-level pour un même module.
 */
const LotsListPage = lazy(() => import('./pages/LotsList'));
const LotDetailPage = lazy(() => import('./pages/LotDetail'));

const listRoute: ModuleRoute = {
  path: 'lots',
  label: 'Fiche lot',
  icon: 'package',
  element: (
    <Suspense
      fallback={
        <div className="p-6 text-sm text-slate-500" role="status" aria-live="polite">
          Chargement des lots…
        </div>
      }
    >
      <LotsListPage />
    </Suspense>
  ),
};

const detailRoute: ModuleRoute = {
  path: 'lot-detail/:numLot',
  label: 'Fiche lot',
  icon: 'package',
  hidden: true,
  element: (
    <Suspense
      fallback={
        <div className="p-6 text-sm text-slate-500" role="status" aria-live="polite">
          Chargement de la fiche lot…
        </div>
      }
    >
      <LotDetailPage />
    </Suspense>
  ),
};

export default [listRoute, detailRoute];
